import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

import RichTextLabelControl from './components/RichTextLabelControl';
import RequiredControl from './components/RequiredControl';
import DateRangeControl from './components/DateRangeControl';
import ReservedNodeIndication from './components/ReservedNodeIndication';
import EditViewSectionContainer from './EditViewSectionContainer';
import { getEditFormNodeId, getEditFormNode } from '../../selectors';
import getReservedInputNameLabel from '../../utils/getReservedInputNameLabel';

const getTooltipContent = (label) => `You may modify the label of this question.
RSVP answers will appear in the "${label}" column of the guest list`;

/**
 * Component for main guest information fields like first name, last name and email.
 */
const CheckInOutEditView = (props) => (
    <React.Fragment>
        <RequiredControl />
        <EditViewSectionContainer>
            <SuiContainer variation="flex-group">
                <RichTextLabelControl formNodeId={props.formNodeId} />
            </SuiContainer>

            <SuiContainer variation="flex-group">
                <DateRangeControl formNodeId={props.formNodeId} />
            </SuiContainer>
            <ReservedNodeIndication
                label={getReservedInputNameLabel(props.name)}
                tooltip={getTooltipContent(getReservedInputNameLabel(props.name))}
            />
        </EditViewSectionContainer>
    </React.Fragment>
);

CheckInOutEditView.propTypes = {
    name: PropTypes.string.isRequired,
    formNodeId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const node = getEditFormNode(state);
    const formNodeId = getEditFormNodeId(state);

    return {
        formNodeId,
        name: node ? node.name : undefined,
    };
};

export default connect(mapStateToProps)(CheckInOutEditView);
